import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { localizedPath } from '../constants/routes';

/**
 * Returns a function that prefixes an internal path with the active language,
 * e.g. lp('/privacy') -> '/de/privacy'. Use it for every internal link so
 * navigation never drops out of the current language.
 */
export const useLocalizedPath = () => {
  const { language } = useLanguage();

  return useCallback((path: string) => localizedPath(path, language), [language]);
};
